import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 28px 15px;

  [class*=" cl-"] {
    font-size: 96px;
  }

  img {
    width: 96px;
  }

  h3 {
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 16px;
    margin-top: 24px;
  }
  p {
    margin: 0
  }
`;
